import { render, staticRenderFns } from "./VirtualDeviceInfo.vue?vue&type=template&id=23446c67&scoped=true&"
import script from "./VirtualDeviceInfo.vue?vue&type=script&lang=js&"
export * from "./VirtualDeviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23446c67",
  null
  
)

export default component.exports